export default __webpack_public_path__ + "static/media/logo_header.70c53869.svg";